/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Shop_Show_WebInputs */

const vi_shop_show_web = /** @type {(inputs: Shop_Show_WebInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hiện web`)
};

/**

* @param {Shop_Show_WebInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const shop_show_web = /** @type {((inputs?: Shop_Show_WebInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Shop_Show_WebInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_shop_show_web(inputs)
});